<template>
	<div
		class="font-weight-400 font-roboto font-size-16 wrapper d-flex flex-row nowrap flex-lg-row nowrap w-100 h-100 form-control mb-3 mb-lg-0 p-0 position-relative justify-content-center align-items-center"
		:style="{ color: colors.black }"
	>
		<DatepickerDropdown />

		<div
			:style="
				datepickerOpen === 'start' && {
					'box-shadow': `0px 0px 0px 2px ${colors.darkBlue}`,
					color: colors.darkBlue,
				}
			"
			@click.stop="() => handleOpenDatepicker('start')"
			class="start-field cursor-pointer px-1 px-lg-3 py-3 col-5 col-lg-6 d-flex flex-column h-100 position-relative"
		>
			<span v-if="startDate" class="text-center text-lg-start">{{
				startDate
			}}</span>
			<span v-else class="text-center text-lg-start text-capitalize">{{
				content.planner_datePickerFrom
			}}</span>
			<ClsBtn
				v-if="startDate"
				@click="handleStartCrossClick"
				:stop="true"
				:classes="'d-none d-sm-block datepicker-cls position-absolute'"
			/>
		</div>

		<!-- mobile arrow -->
		<div
			class="d-flex d-lg-none align-items-center col-2 justify-content-center text-primary-black"
		>
			<svg class="icon" width="20" height="20">
				<use xlink:href="#___icon___arrow-right"></use>
			</svg>
		</div>
		<!-- / mobile arrow -->

		<div
			:style="
				datepickerOpen === 'end' && {
					'box-shadow': `0px 0px 0px 2px ${colors.darkBlue}`,
					color: colors.darkBlue,
				}
			"
			@click.stop="() => handleOpenDatepicker('end')"
			class="end-field cursor-pointer px-1 px-lg-3 py-3 col-5 col-lg-6 d-flex flex-column h-100 position-relative"
		>
			<span v-if="endDate" class="text-center text-lg-start">{{
				endDate
			}}</span>
			<span v-else class="text-start text-lg-start text-capitalize">{{
				content.planner_datePickerTill
			}}</span>
			<ClsBtn
				v-if="endDate"
				@click="handleEndCrossClick"
				:stop="true"
				:classes="'d-none d-sm-block datepicker-cls position-absolute'"
			/>
		</div>
	</div>
</template>

<script>
import DatepickerDropdown from "@/vue/planning/components/search/datepickerDropdown.vue";
import colors from "@/config/colors";
import { mapState } from "vuex";
import ClsBtn from "@/vue/common/clsBtn.vue";
import store from "@/vue/planning/store/store";

export default {
	store,
	name: "Datepicker",
	components: {
		DatepickerDropdown,
		ClsBtn,
	},

	data() {
		return {
			colors,
			state: {
				showStartDate: true,
				showEndDate: true,
			},
		};
	},

	computed: {
		...mapState([
			"content",
			"dates",
			"datepickerOpen",
			"datepickerStartDate",
			"datepickerEndDate",
			"loading",
		]),

		currentStartDateInURL() {
			const [day, month, year] = this.dates["BeginDate"].split("/");
			return new Date(`${year}-${month}-${day}`);
		},
		currentEndDateInURL() {
			const [day, month, year] = this.dates["EndDate"].split("/");
			return new Date(`${year}-${month}-${day}`);
		},

		startDate() {
			if (!this.state.showStartDate) return null;

			if (this.datepickerStartDate) {
				return this.datepickerStartDate.toLocaleDateString("fr");
			} else if (this.dates["BeginDate"]) {
				return this.dates["BeginDate"];
			}
			return null;
		},
		endDate() {
			if (!this.state.showEndDate) return null;

			if (this.datepickerStartDate && this.datepickerEndDate) {
				if (
					this.datepickerStartDate.toLocaleDateString("fr") ===
					this.datepickerEndDate.toLocaleDateString("fr")
				)
					return null;
				return this.datepickerEndDate.toLocaleDateString("fr");
			} else if (this.dates["EndDate"]) {
				return this.dates["EndDate"];
			}
			return null;
		},
		disabled() {
			return this.loading;
		},
	},
	methods: {
		handleStartCrossClick() {
			this.$store.dispatch("setDatepickerOpen", "start");
			this.$nextTick(() => {
				this.setShowStartDate(false);
				this.setShowEndDate(false);
			});
		},

		handleEndCrossClick() {
			this.$store.commit("setDatepickerStartDate", this.datepickerStartDate);
			this.$store.commit("setDatepickerEndDate", this.datepickerStartDate);
			this.$store.dispatch("setDatepickerOpen", "end");
			this.$nextTick(() => {
				// without nextTick the very first click doesnt clear the end date, but all subsequent do. Mystery, so I just fixed it adding a nextTick.
				this.setShowEndDate(false);
			});
		},

		setShowStartDate(bool) {
			this.$set(this.state, "showStartDate", bool);
		},

		setShowEndDate(bool) {
			this.$set(this.state, "showEndDate", bool);
		},

		async handleOpenDatepicker(str) {
			if (this.datepickerOpen === str) {
				// closes datepicker if same side is open that was clicked
				this.$store.dispatch("setDatepickerOpen", "");
			} else if (str === "end") {
				this.$store.commit("setDatepickerStartDate", this.datepickerStartDate);
				this.$store.commit("setDatepickerEndDate", this.datepickerEndDate);
				this.$store.dispatch("setDatepickerOpen", "end");
			} else {
				this.$store.dispatch("setDatepickerOpen", "start");
			}
		},
	},

	watch: {
		datepickerOpen: function (newVal, oldVal) {
			if (!newVal) {
				this.$set(this.state, "showStartDate", true);
				this.$set(this.state, "showEndDate", true);
			}
		},
		datepickerStartDate: function (newVal, oldVal) {
			if (newVal) {
				this.$set(this.state, "showStartDate", true);
			}
		},
		datepickerEndDate: function (newVal, oldVal) {
			if (newVal) {
				// localStorage.setItem("newEndDate", this.dates["EndDate"]);
				this.$set(this.state, "showEndDate", true);
			}
		},

		dates: function () {
			this.$set(this.state, "season", "H");

			this.$store.commit("setDatepickerStartDate", this.currentStartDateInURL);
			this.$store.commit("setDatepickerEndDate", this.currentEndDateInURL);
		},
	},
};
</script>

<style scoped>
.datepicker-cls {
	top: 50%;
	right: 12px;
	transform: translateY(-50%);
}

.wrapper {
	border-radius: 8px;
}
.start-field {
	border-radius: 8px 0px 0px 8px;
}

.end-field {
	border-radius: 0px 8px 8px 0px;
}

@media only screen and (min-width: 992px) {
	.start-field {
		border-right: 1px solid lightgray;
	}

	.wrapper {
		border-radius: 8px !important;
	}
}
</style>
